"use client";

import type { RssVideo } from "@jesus-central-church/youtube";
import { useState } from "react";
import SermonCard from "./SermonCard";
import SermonHighlight from "./SermonHighlight";
import SermonModal from "./SermonModal";

export default function SermonList({ sermons }: { sermons: RssVideo[] }) {
  const [open, setOpen] = useState<string | null>(null);
  const sortedSermons = sermons.sort(
    (a, b) =>
      new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );

  const latestSermon = sortedSermons[0];

  return (
    <>
      <SermonHighlight
        youtubeUrl={latestSermon.url}
        title={latestSermon.title}
        date={latestSermon.publishedAt}
        thumbnail={{ src: latestSermon.thumbnailUrl, alt: latestSermon.title }}
      />
      <section className="mx-auto max-w-7xl grid grid-cols-1 gap-4 px-4 pt-12 sm:grid-cols-2 sm:gap-6 sm:px-6 md:gap-8 lg:grid-cols-3 lg:px-8">
        {sortedSermons.slice(1).map((item) => (
          <SermonCard key={item.videoId} video={item} onOpen={setOpen} />
        ))}

        <SermonModal videoId={open} onClose={() => setOpen(null)} />
      </section>
    </>
  );
}
